/* BR FAVORITTER (29/10-2026, Omars go): hjerte på produktkort + produktside, tæller i headeren, favoritside.
   Listen ligger i browserens localStorage (br_favoritter_v1). Kunden gemmer selv med et klik → ingen cookie-samtykke nødvendigt.
   Hver post: p[nøgle] = {h: handle, a: tilføjet-ms, r: fjernet-ms (0 = aktiv), v: variant-id, pr: pris i øre ved gem}.
   Nøgle = "produktId:variantId" når kunden har valgt variant (produktsiden), ellers "produktId" (kort uden valg). Fjernede poster gemmes som "gravsten",
   så en senere synkronisering på tværs af enheder (trin 3) kan se, hvad der er nyest. Gravsten > 180 d ryddes.
   Pris/billede/lager gemmes IKKE – de hentes fra Shopify (/products/<handle>.js), når listen vises, så de altid er aktuelle.
   Sporing: hændelsen 'favorit' via beacon v8 (window.__brV8log), hvis den findes. */
(function () {
  if (window.BRFav) return;
  var NOGLE = 'br_favoritter_v1', MAKS = 100, GRAVSTEN_MS = 180 * 864e5;
  var LISTE_URL = window.BR_FAV_URL || '/pages/favoritter';
  var HJERTE = '<svg class="br-fav__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/></svg>';

  /* laes() kaldes for hvert hjerte på siden – den rå streng caches, så JSON kun parses når den har ændret sig */
  var cacheRaa = null, cacheD = null;
  function laes() {
    var raa = null; try { raa = localStorage.getItem(NOGLE); } catch (e) {}
    if (raa !== cacheRaa || !cacheD) { cacheRaa = raa; cacheD = null; try { var d = JSON.parse(raa || 'null'); if (d && d.p && typeof d.p === 'object') cacheD = d; } catch (e) {} if (!cacheD) cacheD = { v: 1, p: {} }; }
    return JSON.parse(JSON.stringify(cacheD));
  }
  function gem(d) {
    var nu = Date.now();
    for (var id in d.p) { var x = d.p[id]; if (x.r && nu - x.r > GRAVSTEN_MS) delete d.p[id]; }
    try { localStorage.setItem(NOGLE, JSON.stringify(d)); return true; } catch (e) { return false; }
  }
  function pidAf(noegle) { return String(noegle).split(':')[0]; }
  function aktive() {
    var d = laes(), ud = [];
    for (var id in d.p) { var x = d.p[id]; if (x && !x.r && x.h) ud.push({ id: id, pid: pidAf(id), h: x.h, a: x.a || 0, v: x.v || null, pr: x.pr || null }); }
    ud.sort(function (a, b) { return b.a - a.a; });
    return ud;
  }
  /* "pid:vid" = netop den variant · "pid" = produktet (gemt i en hvilken som helst variant eller uden valg) */
  function erGemt(noegle) {
    noegle = String(noegle); var d = laes();
    if (noegle.indexOf(':') > -1) { var x = d.p[noegle]; return !!(x && !x.r); }
    for (var id in d.p) if (!d.p[id].r && pidAf(id) === noegle) return true;
    return false;
  }

  function spor(handling, noegle, h, kilde, pris) {
    try { if (window.__brV8log) window.__brV8log('favorit', { handling: handling, produkt_id: pidAf(noegle), variant_id: String(noegle).indexOf(':') > -1 ? String(noegle).split(':')[1] : null, handle: h, kilde: kilde || null, pris: pris ? Math.round(+pris) / 100 : null, antal: aktive().length }, true); } catch (e) {}
  }

  /* Gem: nøglen gemmes; en variant afløser en generel post for samme produkt. Fjern: med en variant-nøgle kun den variant,
     med en produkt-nøgle (kort) alle poster for produktet. Returnerer de berørte nøgler (bruges af Fortryd). */
  function saet(noegle, h, til, kilde, pr) {
    noegle = String(noegle); var d = laes(), nu = tid(), pid = pidAf(noegle), beroert = [];
    if (til) {
      if (!erGemt(noegle) && aktive().length >= MAKS) { toast('Din liste er fuld. Fjern noget for at gemme mere.', null); return null; }
      d.p[noegle] = { h: h, a: nu, r: 0, v: noegle.indexOf(':') > -1 ? noegle.split(':')[1] : null, pr: pr ? Math.round(+pr) : null };
      beroert.push(noegle);
      if (noegle !== pid && d.p[pid] && !d.p[pid].r) { d.p[pid].r = nu; beroert.push(pid); }
    } else if (noegle.indexOf(':') > -1) {
      var x = d.p[noegle] || { h: h, a: 0 }; x.r = nu; d.p[noegle] = x; beroert.push(noegle);
    } else {
      for (var id in d.p) if (!d.p[id].r && pidAf(id) === pid) { d.p[id].r = nu; beroert.push(id); }
    }
    if (!gem(d)) { toast('Din browser tillader ikke at gemme favoritter.', null); return null; }
    opdater();
    spor(til ? 'gem' : 'fjern', noegle, h, kilde, pr);
    try { window.dispatchEvent(new CustomEvent('br:favoritter', { detail: { id: noegle, ids: beroert, gemt: til, fraListe: kilde === 'liste' } })); } catch (e) {}
    planlaegSync();
    return beroert;
  }
  function genopret(noegler) {
    var d = laes(); var nu = tid(); noegler.forEach(function (n) { if (d.p[n]) { d.p[n].r = 0; d.p[n].a = nu; } }); gem(d); opdater();
    try { window.dispatchEvent(new CustomEvent('br:favoritter', { detail: { id: noegler[0], ids: noegler, gemt: true } })); } catch (e) {}
    planlaegSync();
  }

  /* ---------- e-mail-liste (trin 3): listen gemmes også i Supabase via edge function 'favoritter' ----------
     Kunden får et link på mail; linkets nøgle står efter # (fanges og fjernes øverst i <head>, før andre scripts kører) og gemmes
     her i localStorage. Ved tilmelding og når linket åbnes (sync m. tilslut:true) er DENNE enhed sandheden for de poster, den kender:
     aktive kommer på listen, fjernede fjernes – stemplet i server-tid, så det følger med til alle enheder. Derefter almindelig synk:
     nyeste handling pr. post vinder (gravsten gør at fjernede poster ikke genopstår). Nøglen giver kun adgang til ønskelisten. */
  var API = window.BR_FAV_API || null, TOK = 'br_favoritter_noegle', syncTimer = null, konto = null, sidstSync = 0;
  /* alle gem-/fjern-tider stemples i SERVER-tid: serveren sender sin tid (nu) i hvert svar, forskellen huskes. Et ur, der går
     forkert på én enhed, må ikke afgøre, hvad der er "nyest" på tværs af enheder (gik uret foran, kunne andre aldrig fjerne posten). */
  var skew = 0; try { skew = +localStorage.getItem('br_favoritter_skew') || 0; } catch (e) {}
  function tid() { return Date.now() + skew; }
  function token() { try { return localStorage.getItem(TOK); } catch (e) { return null; } }
  function saetKonto(j) { konto = { email: j.email, samtykke: j.samtykke }; }
  var fuldVist = false;
  function glemToken() { try { localStorage.removeItem(TOK); } catch (e) {} konto = null; }
  function api(body) {
    if (!API) return Promise.reject(new Error('api'));
    body.k = API.k;
    return fetch(API.u, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body) }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (typeof j.nu === 'number') { skew = Math.abs(j.nu - Date.now()) > 5000 ? j.nu - Date.now() : 0; try { localStorage.setItem('br_favoritter_skew', String(skew)); } catch (e) {} }
        if (!r.ok) { var e = new Error(j.error || String(r.status)); e.status = r.status; throw e; } return j;
      });
    });
  }
  function fletServer(poster) {
    var d = laes(), aendret = false;
    (poster || []).forEach(function (p) {
      var l = d.p[p.noegle], ny = Math.max(p.a || 0, p.r || 0), gl = l ? Math.max(l.a || 0, l.r || 0) : -1;
      if (ny > gl) { d.p[p.noegle] = { h: p.h, a: p.a, r: p.r || 0, v: p.noegle.indexOf(':') > -1 ? p.noegle.split(':')[1] : null, pr: p.pr || (l && l.pr) || null }; aendret = true; }
    });
    if (aendret) { gem(d); opdater(); try { window.dispatchEvent(new CustomEvent('br:favoritter-sync')); } catch (e) {} }
    return aendret;
  }
  function planlaegSync() { if (!token()) return; clearTimeout(syncTimer); syncTimer = setTimeout(function () { syncTimer = null; syncNu(); }, 1200); }
  function syncNu() {
    var t = token(); if (!t) return Promise.resolve(false); sidstSync = Date.now();
    return api({ handling: 'sync', token: t, poster: laes().p }).then(function (j) { saetKonto(j); return fletServer(j.poster); })
      .catch(function (e) {
        if (e.status === 401) { glemToken(); toast('Denne enhed er logget ud af listen på din e-mail. Listen ligger stadig her.', null); try { window.dispatchEvent(new CustomEvent('br:favoritter-sync')); } catch (x) {} }
        else if (e.message === 'for mange' && !fuldVist) { fuldVist = true; toast('Listen på din e-mail er fuld. Fjern noget for at gemme mere.', null); }
        return false;
      });
  }

  /* produktsidens hjerte gemmer den valgte variant (input[name=id] i produktformularen) + dens pris */
  function noegleFor(k) {
    var pid = k.getAttribute('data-id');
    if (!k.hasAttribute('data-br-fav-variant')) return pid;
    var f = k.closest('form') || document.querySelector('product-form form'), inp = f && f.querySelector('input[name="id"]');
    return inp && inp.value ? pid + ':' + inp.value : pid;
  }
  function prisFor(k, noegle) {
    if (noegle.indexOf(':') > -1) {
      try { var vid = +noegle.split(':')[1], vs = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.variants) || [];
        for (var i = 0; i < vs.length; i++) if (vs[i].id === vid && vs[i].price) return vs[i].price; } catch (e) {}
    }
    var p = k.getAttribute('data-pris'); return p ? +p : null;
  }

  /* ---------- knapper + headertæller ---------- */
  function opdater() {
    var n = aktive().length;
    var knapper = document.querySelectorAll('[data-br-fav]');
    for (var i = 0; i < knapper.length; i++) {
      var k = knapper[i], g = erGemt(noegleFor(k));
      if ((k.getAttribute('aria-pressed') === 'true') !== g) {
        k.setAttribute('aria-pressed', g ? 'true' : 'false');
        k.setAttribute('aria-label', g ? 'Fjern fra favoritter' : 'Gem i favoritter');
      }
    }
    var t = document.querySelectorAll('[data-br-fav-antal]');
    for (var j = 0; j < t.length; j++) { t[j].textContent = n; t[j].classList.toggle('br-fav-antal--skjult', n === 0); }
    var l = document.querySelectorAll('[data-br-fav-link]');
    for (var m = 0; m < l.length; m++) l[m].setAttribute('aria-label', n ? 'Favoritter, ' + n + ' gemt' : 'Favoritter');
  }

  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-br-fav]');
    if (!k) return;
    e.preventDefault(); e.stopPropagation();
    var noegle = noegleFor(k), til = !erGemt(noegle), beroert = saet(noegle, k.getAttribute('data-handle'), til, k.getAttribute('data-kilde'), prisFor(k, noegle));
    if (!beroert) return;
    k.classList.remove('br-fav--pop'); void k.offsetWidth; if (til) k.classList.add('br-fav--pop');
    if (til) flyv(k);
    if (til) toast('Gemt i favoritter', (!token() && API && aktive().length >= 2) ? { tekst: 'Få listen på mail', href: LISTE_URL + '#mail' } : { tekst: 'Se listen', href: LISTE_URL });
    else toast(beroert.length > 1 ? 'Fjernet fra favoritter (' + beroert.length + ' varianter)' : 'Fjernet fra favoritter', { tekst: 'Fortryd', fn: function () { genopret(beroert); } });
  }, true);

  /* ---------- flyvende hjerte (Omar 29/10): fra det trykkede hjerte op i headerens hjerte, som bliver orange og falmer ---------- */
  function fyld(maal) { maal.classList.remove('br-header__fav--fyldt'); void maal.offsetWidth; maal.classList.add('br-header__fav--fyldt'); setTimeout(function () { maal.classList.remove('br-header__fav--fyldt'); }, 1300); }
  function flyv(fra) {
    var maal = null, hl = document.querySelectorAll('.br-header__fav');
    for (var i = 0; i < hl.length; i++) if (hl[i].offsetParent && getComputedStyle(hl[i]).display !== 'none') { maal = hl[i]; break; }
    if (!maal) return;
    var m = (maal.querySelector('.icon-fav') || maal).getBoundingClientRect(), a = (fra.querySelector('.br-fav__ikon') || fra).getBoundingClientRect();
    var rolig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (rolig || !Element.prototype.animate || m.bottom < 0 || m.top > window.innerHeight) { fyld(maal); return; }
    var str = Math.max(18, Math.min(28, a.width)), el = document.createElement('div');
    el.className = 'br-fav-flyver'; el.innerHTML = HJERTE;
    el.style.left = (a.left + a.width / 2 - str / 2) + 'px'; el.style.top = (a.top + a.height / 2 - str / 2) + 'px'; el.style.width = el.style.height = str + 'px';
    document.body.appendChild(el);
    var dx = (m.left + m.width / 2) - (a.left + a.width / 2), dy = (m.top + m.height / 2) - (a.top + a.height / 2), slut = m.height / str;
    var anim = el.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.3 + 'px,' + (dy * 0.3 - 40) + 'px) scale(1.35)', opacity: 1, offset: 0.35 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + slut + ')', opacity: 0.85 }
    ], { duration: 700, easing: 'cubic-bezier(.45,0,.25,1)' });
    var faerdig = false, slutt = function () { if (faerdig) return; faerdig = true; el.remove(); fyld(maal); };
    anim.onfinish = slutt; setTimeout(slutt, 1000);
  }

  /* ---------- besked nederst ---------- */
  var toastEl, toastTimer;
  function toast(tekst, handling) {
    if (!toastEl) {
      toastEl = document.createElement('div'); toastEl.className = 'br-fav-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span class="br-fav-toast__tekst">' + HJERTE + '<span></span></span>';
    toastEl.querySelector('.br-fav-toast__tekst span').textContent = tekst;
    if (handling) {
      var a = document.createElement(handling.href ? 'a' : 'button'); a.className = 'br-fav-toast__knap'; a.textContent = handling.tekst;
      if (handling.href) a.href = handling.href; else { a.type = 'button'; a.addEventListener('click', function () { handling.fn(); skjul(); }); }
      toastEl.appendChild(a);
    }
    toastEl.classList.add('br-fav-toast--vis');
    clearTimeout(toastTimer); toastTimer = setTimeout(skjul, handling && handling.fn ? 7000 : 4500);
    if (!toastEl.__pause) {
      toastEl.__pause = true;
      var stop = function () { clearTimeout(toastTimer); }, igen = function () { clearTimeout(toastTimer); toastTimer = setTimeout(skjul, 2500); };
      toastEl.addEventListener('mouseenter', stop); toastEl.addEventListener('focusin', stop);
      toastEl.addEventListener('mouseleave', igen); toastEl.addEventListener('focusout', igen);
    }
  }
  function skjul() { if (toastEl) toastEl.classList.remove('br-fav-toast--vis'); }

  /* ---------- favoritsiden ---------- */
  function kr(oere) { var v = oere / 100; return v.toLocaleString('da-DK', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' kr'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function billede(src, w) { if (!src) return ''; src = src.indexOf('//') === 0 ? 'https:' + src : src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  /* null = produktet findes ikke (404) · FEJL = kunne ikke hentes lige nu (net/server) – så må kunden ikke få at vide at det er væk */
  var FEJL = { fejl: true }, koe = [], igang = 0;
  function hent(h) {
    return new Promise(function (ok) { koe.push(function () {
      fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : (r.status === 404 ? null : FEJL); }).catch(function () { return FEJL; })
        .then(function (p) { igang--; ok(p); naeste(); });
    }); naeste(); });
  }
  function naeste() { while (igang < 6 && koe.length) { igang++; koe.shift()(); } }
  function valgTekst(p) {
    var navne = (p.options || []).map(function (o) { return (o && o.name ? o.name : String(o)).toLowerCase(); }).join(' ');
    if (/størrelse|str\b|mål/.test(navne)) return 'Vælg størrelse';
    if (/farve/.test(navne)) return 'Vælg farve';
    return 'Vælg variant';
  }

  /* udfyldt hjerte øverst th. på kortet – vises kun på computer (telefon har "Fjern") */
  function hjerteKnap(noegle, h) { return '<button type="button" class="br-favs__hjerte" data-br-fav-fjern="' + esc(noegle) + '" data-handle="' + esc(h) + '" aria-label="Fjern fra favoritter"><span class="br-fav__cirkel">' + HJERTE + '</span></button>'; }
  function raekke(p, x) {
    if (p === FEJL) {
      return '<li class="br-favs__r br-favs__r--vaek" data-id="' + esc(x.id) + '"><div class="br-favs__bi"></div><div class="br-favs__info"><span class="br-favs__navn">Kunne ikke hentes lige nu</span>' +
        '<div class="br-favs__knapper"><button type="button" class="br-favs__fjern" data-br-favs-igen>Prøv igen</button></div></div></li>';
    }
    if (!p) {
      return '<li class="br-favs__r br-favs__r--vaek" data-id="' + esc(x.id) + '"><div class="br-favs__bi"></div><div class="br-favs__info"><span class="br-favs__navn">Produktet findes ikke længere</span>' +
        '<div class="br-favs__knapper"><button type="button" class="br-favs__fjern" data-br-fav-fjern="' + esc(x.id) + '" data-handle="' + esc(x.h) + '">Fjern</button></div></div></li>';
    }
    var url = p.url || '/products/' + p.handle, enkel = p.variants && p.variants.length === 1;
    var v = null; if (x.v) for (var i = 0; i < (p.variants || []).length; i++) if (String(p.variants[i].id) === String(x.v)) v = p.variants[i];
    if (!v && enkel) v = p.variants[0];
    var knap, pris, foer = '', ledig, bil = p.featured_image, valg = '';
    if (v) {
      url += (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id;
      pris = '<b>' + kr(v.price) + '</b>'; if (v.compare_at_price && v.compare_at_price > v.price) foer = '<s>' + kr(v.compare_at_price) + '</s>';
      ledig = v.available; if (v.featured_image && v.featured_image.src) bil = v.featured_image.src;
      if (!enkel && v.title && v.title !== 'Default Title') valg = '<span class="br-favs__valg">' + esc(v.title.split(' / ').join(' · ')) + '</span>';
      knap = ledig ? '<button type="button" class="br-favs__kurv" data-br-fav-kurv="' + v.id + '">Læg i kurv</button>' : '<a class="br-favs__vaelg" href="' + esc(url) + '">Se produktet</a>';
    } else {
      pris = '<b>' + (p.price_varies ? 'Fra ' : '') + kr(p.price_min) + '</b>';
      if (!p.price_varies && p.compare_at_price && p.compare_at_price > p.price) foer = '<s>' + kr(p.compare_at_price) + '</s>';
      ledig = p.available;
      knap = '<a class="br-favs__vaelg" href="' + esc(url) + '">' + (ledig ? valgTekst(p) : 'Se produktet') + '</a>';
    }
    return '<li class="br-favs__r" data-id="' + esc(x.id) + '">' + hjerteKnap(x.id, p.handle) +
      '<a class="br-favs__bi" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + (bil ? '<img src="' + esc(billede(bil, 240)) + '" alt="" loading="lazy" width="96" height="96">' : '') + '</a>' +
      '<div class="br-favs__info"><a class="br-favs__navn" href="' + esc(url) + '">' + esc(p.title) + '</a>' + valg +
      '<div class="br-favs__pris">' + pris + foer + '</div>' +
      (ledig ? '<span class="br-favs__lager">● På lager</span>' : '<span class="br-favs__lager br-favs__lager--ude">Udsolgt</span>') +
      '<div class="br-favs__knapper">' + knap + '<button type="button" class="br-favs__fjern" data-br-fav-fjern="' + esc(x.id) + '" data-handle="' + esc(p.handle) + '">Fjern</button></div></div></li>';
  }

  /* tom liste: mailboksen bruges til at hente en liste gemt på en anden enhed (Omar 29/10) – teksterne står i data-tom i sektionen */
  function mailTekst(rod) {
    var tomt = aktive().length === 0, el = rod.querySelectorAll('[data-br-favs-mail] [data-tom]');
    for (var i = 0; i < el.length; i++) { if (!el[i].hasAttribute('data-fuld')) el[i].setAttribute('data-fuld', el[i].textContent); el[i].textContent = tomt ? el[i].getAttribute('data-tom') : el[i].getAttribute('data-fuld'); }
  }
  function tael(rod) {
    mailTekst(rod);
    var n = aktive().length, antal = rod.querySelector('[data-br-favs-antal]'), tom = rod.querySelector('[data-br-favs-tom]');
    if (antal) antal.textContent = n === 1 ? '1 gemt produkt' : n + ' gemte produkter';
    if (tom) tom.hidden = n > 0;
  }
  var listeKoersel = 0;
  function visListe(rod) {
    var koersel = ++listeKoersel; mailTekst(rod);
    var liste = aktive(), ul = rod.querySelector('[data-br-favs-liste]'), tom = rod.querySelector('[data-br-favs-tom]'), antal = rod.querySelector('[data-br-favs-antal]');
    if (antal) antal.textContent = liste.length === 1 ? '1 gemt produkt' : liste.length + ' gemte produkter';
    if (tom) tom.hidden = liste.length > 0;
    if (!ul) return;
    if (!liste.length) { ul.innerHTML = ''; return; }
    ul.setAttribute('aria-busy', 'true');
    ul.innerHTML = liste.map(function () { return '<li class="br-favs__r br-favs__r--hent"><div class="br-favs__bi"></div><div class="br-favs__info"></div></li>'; }).join('');
    Promise.all(liste.map(function (x) { return hent(x.h); })).then(function (ps) {
      if (koersel !== listeKoersel) return;
      ul.innerHTML = ps.map(function (p, i) { return raekke(p, liste[i]); }).join('');
      ul.removeAttribute('aria-busy');
    });
  }

  function visSete(rod) {
    var boks = rod.querySelector('[data-br-sete]'); if (!boks) return;
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem('recently_viewed_products') || '[]'); } catch (e) {}
    var gemte = {}; aktive().forEach(function (x) { gemte[x.h] = 1; });
    handles = (Array.isArray(handles) ? handles : []).filter(function (h) { return h && !gemte[h]; }).slice(0, 8);
    if (!handles.length) { boks.hidden = true; return; }
    Promise.all(handles.map(hent)).then(function (ps) {
      ps = ps.filter(function (p) { return p && p !== FEJL; }); if (!ps.length) { boks.hidden = true; return; }
      boks.querySelector('[data-br-sete-raekke]').innerHTML = ps.map(function (p) {
        return '<div class="br-sete__w"><a class="br-sete__k" href="' + esc(p.url) + '" data-br-sete-klik="' + p.id + '"><span class="br-sete__bi">' + (p.featured_image ? '<img src="' + esc(billede(p.featured_image, 300)) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="br-sete__navn">' + esc(p.title) + '</span><b class="br-sete__pris">' + (p.price_varies ? 'Fra ' : '') + kr(p.price_min) + '</b></a>' +
          '<button type="button" class="br-fav br-fav--kort br-fav--sete" data-br-fav data-id="' + p.id + '" data-handle="' + esc(p.handle) + '" data-pris="' + Math.round(p.price_min) + '" data-kilde="sete" aria-pressed="' + (erGemt(p.id) ? 'true' : 'false') + '" aria-label="' + (erGemt(p.id) ? 'Fjern fra favoritter' : 'Gem i favoritter') + '"><span class="br-fav__cirkel">' + HJERTE + '</span></button></div>';
      }).join('');
      boks.hidden = false;
    });
  }

  function opdaterKurvTal() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var b = document.querySelector('.br-header__cart-count'); if (!b) return;
      b.textContent = c.item_count; b.classList.toggle('br-header__cart-count--hidden', !c.item_count);
    }).catch(function () {});
  }

  function visKonto(rod) {
    var boks = rod.querySelector('[data-br-favs-mail]'), linje = rod.querySelector('[data-br-favs-konto]'), noter = rod.querySelectorAll('.br-favs__note');
    var t = token();
    if (boks) boks.hidden = !!t || !API;
    if (linje) { linje.hidden = !t; if (t) { var em = linje.querySelector('[data-br-favs-email]'); if (em) em.textContent = konto && konto.email ? konto.email : 'din e-mail'; } }
    for (var i = 0; i < noter.length; i++) noter[i].hidden = !!t;
  }
  function sideSti() { return location.pathname + (/view=favoritter/.test(location.search) ? '?view=favoritter' : ''); }
  function initMail(rod) {
    var form = rod.querySelector('[data-br-favs-form]'), svar = rod.querySelector('[data-br-favs-svar]');
    /* "Send igen" først efter 30 s; serveren sender højst 3 linkmails pr. e-mail i timen, så efter 3. forsøg siges det ærligt */
    var linje = rod.querySelector('[data-br-favs-igen-linje]'), igenKnap = rod.querySelector('[data-br-favs-send-igen]'), igenTekst = rod.querySelector('[data-br-favs-igen-tekst]');
    var sidstEmail = null, sidstJa = false, forsoeg = {}, ventTimer = null;
    function vent() {
      if (!igenKnap) return; var s = 30; igenKnap.disabled = true; clearInterval(ventTimer);
      igenKnap.textContent = 'Send igen om ' + s + ' s';
      ventTimer = setInterval(function () { s--; if (s > 0) igenKnap.textContent = 'Send igen om ' + s + ' s'; else { clearInterval(ventTimer); igenKnap.disabled = false; igenKnap.textContent = 'Send igen'; } }, 1000);
    }
    function visIgen() {
      if (!linje) return; linje.hidden = false;
      if ((forsoeg[sidstEmail] || 0) >= 3) { clearInterval(ventTimer); igenTekst.textContent = 'Vi har sendt den 3 gange. Kig i spam, eller prøv igen om en time.'; igenKnap.hidden = true; return; }
      igenTekst.textContent = 'Ikke modtaget?'; igenKnap.hidden = false; vent();
    }
    function send(email, ja) {
      return api({ handling: 'tilmeld', email: email, samtykke: ja, samtykke_tekst: ja ? (rod.querySelector('[data-br-favs-samtykketekst]') || {}).textContent : null, side: sideSti(), poster: laes().p })
        .then(function (j) { sidstEmail = email; sidstJa = ja; forsoeg[email] = j && j.begraenset ? 3 : (forsoeg[email] || 0) + 1; try { sessionStorage.setItem('br_fav_sendt', email); } catch (e) {} return j || {}; });
    }
    function visSendt(email, j) {
      form.hidden = true; svar.textContent = ''; var ok = rod.querySelector('[data-br-favs-sendt]');
      if (ok) { ok.hidden = false; ok.querySelector('b').textContent = email; var t = ok.querySelector('[data-br-favs-sendt-tekst]'); if (t && j && j.begraenset) t.textContent = 'Vi har allerede sendt linket flere gange den seneste time. Kig i spam, eller prøv igen om en time. Dine favoriter er lagt på listen.'; }
      visIgen();
    }
    /* siden genindlæst efter tilmelding (uden nøgle endnu): vis stadig "Du er tilmeldt" i stedet for at bede om e-mailen igen */
    try { var husket = !token() && sessionStorage.getItem('br_fav_sendt'); if (husket && form) { sidstEmail = husket; sidstJa = true; forsoeg[husket] = 1; visSendt(husket, null); } } catch (e) {}
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (form.email.value || '').trim(), knap = form.querySelector('button[type="submit"]');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { svar.textContent = 'Tjek e-mailadressen.'; form.email.focus(); return; }
      if ((forsoeg[email] || 0) >= 3) { svar.textContent = 'Vi har sendt den 3 gange. Kig i spam, eller prøv igen om en time.'; return; }
      knap.disabled = true; svar.textContent = 'Sender …';
      send(email, true)
        .then(function (j) { visSendt(email, j); spor('mail_tilmeld', '0', null, 'samtykke'); })
        .catch(function (x) { knap.disabled = false; svar.textContent = x.message === 'email' ? 'Tjek e-mailadressen.' : 'Det lykkedes ikke. Prøv igen om lidt.'; });
    });
    if (igenKnap) igenKnap.addEventListener('click', function () {
      if (!sidstEmail || igenKnap.disabled) return; igenKnap.disabled = true; igenKnap.textContent = 'Sender …';
      send(sidstEmail, sidstJa).then(function (j) { igenTekst.textContent = 'Sendt igen.'; visIgen(); if (j && j.begraenset) igenTekst.textContent = 'Vi har sendt den 3 gange. Kig i spam, eller prøv igen om en time.'; else if ((forsoeg[sidstEmail] || 0) < 3) igenTekst.textContent = 'Sendt igen. Ikke modtaget?'; spor('mail_igen', '0', null, null); })
        .catch(function () { igenKnap.disabled = false; igenKnap.textContent = 'Send igen'; igenTekst.textContent = 'Det lykkedes ikke. Prøv igen om lidt.'; });
    });
    var ret = rod.querySelector('[data-br-favs-ret]');
    if (ret) ret.addEventListener('click', function () {
      clearInterval(ventTimer); if (linje) linje.hidden = true; var ok = rod.querySelector('[data-br-favs-sendt]'); if (ok) ok.hidden = true; try { sessionStorage.removeItem('br_fav_sendt'); } catch (e) {}
      form.hidden = false; form.querySelector('button[type="submit"]').disabled = false; form.email.focus(); form.email.select();
    });
    rod.addEventListener('click', function (e) {
      var lu = e.target.closest('[data-br-favs-logud]'), sl = e.target.closest('[data-br-favs-slet]'); if (!lu && !sl) return;
      var t = token(); if (!t) return;
      if (sl && !sl.hasAttribute('data-bekraeft')) { sl.setAttribute('data-bekraeft', ''); sl.textContent = 'Tryk igen for at slette listen fra din e-mail'; return; }
      api({ handling: lu ? 'log_ud_alle' : 'slet', token: t }).then(function () { glemToken(); visKonto(rod); toast(lu ? 'Alle enheder er logget ud. Listen ligger stadig her.' : 'Listen er slettet fra din e-mail. Den ligger stadig i denne browser.', null); })
        .catch(function () { toast('Det lykkedes ikke. Prøv igen om lidt.', null); });
    });
  }
  function initSide() {
    var rod = document.querySelector('[data-br-favs]'); if (!rod) return;
    visListe(rod); visSete(rod); visKonto(rod); initMail(rod);
    rod.addEventListener('click', function (e) {
      var f = e.target.closest('[data-br-fav-fjern]');
      if (f) {
        var id = f.getAttribute('data-br-fav-fjern'), h = f.getAttribute('data-handle'), li = f.closest('.br-favs__r');
        var naeste = li && li.nextElementSibling, ul = li && li.parentNode, html = li ? li.outerHTML : '';
        var b2 = saet(id.indexOf(':') > -1 ? id : id, h, false, 'liste'); if (!b2) return;
        if (li) li.remove(); tael(rod);
        toast(b2.length > 1 ? 'Fjernet fra favoritter (' + b2.length + ' varianter)' : 'Fjernet fra favoritter', { tekst: 'Fortryd', fn: function () {
          var d = laes(), nu = tid(); b2.forEach(function (n) { if (d.p[n]) { d.p[n].r = 0; d.p[n].a = nu; } }); gem(d); opdater(); spor('gem', id, h, 'liste'); planlaegSync();
          if (ul && html) { if (naeste && naeste.parentNode === ul) naeste.insertAdjacentHTML('beforebegin', html); else ul.insertAdjacentHTML('beforeend', html); }
          tael(rod);
        } });
        return;
      }
      var k = e.target.closest('[data-br-fav-kurv]');
      if (k) {
        k.disabled = true; var org = k.textContent; k.textContent = 'Lægger i kurv…';
        var drawer = document.querySelector('cart-drawer');
        fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: +k.getAttribute('data-br-fav-kurv'), quantity: 1 }], sections: drawer ? ['cart-drawer'] : [], sections_url: location.pathname }) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            k.disabled = false; k.textContent = org;
            if (!res.ok) { toast(res.j && res.j.description ? res.j.description : 'Kunne ikke lægge varen i kurven.', null); return; }
            opdaterKurvTal();
            if (drawer && drawer.renderContents && res.j.sections && res.j.sections['cart-drawer']) { try { drawer.renderContents(res.j); return; } catch (x) {} }
            toast('Lagt i kurven', { tekst: 'Gå til kurv', href: '/cart' });
          })
          .catch(function () { k.disabled = false; k.textContent = org; toast('Kunne ikke lægge varen i kurven.', null); });
        return;
      }
      if (e.target.closest('[data-br-favs-igen]')) { visListe(rod); return; }
      var s = e.target.closest('[data-br-sete-klik]');
      if (s) { try { if (window.__brV8log) window.__brV8log('favorit', { handling: 'sete_klik', produkt_id: s.getAttribute('data-br-sete-klik'), kilde: 'favoritside' }, true); } catch (x) {} }
    });
    window.addEventListener('storage', function (e) { if (e.key === NOGLE) visListe(rod); });
    /* gemt/fjernet via et hjerte på siden (fx i "Senest set"): kun den ene række sættes ind/fjernes – ingen gentegning af
       hele listen – og siden skubbes tilsvarende, så det man trykkede på bliver stående under fingeren (ingen hop) */
    window.addEventListener('br:favoritter', function (e) {
      var d = e.detail || {}; if (d.fraListe) return;
      var ul = rod.querySelector('[data-br-favs-liste]'); if (!ul) return;
      var tom = rod.querySelector('[data-br-favs-tom]');
      var opd = function () { tael(rod); };
      var anker = rod.querySelector('[data-br-sete]');
      var skub = function (fn) {
        var foer = anker && !anker.hidden ? anker.getBoundingClientRect().top : null; fn(); if (foer === null) return;
        /* øjeblikkelig scroll (temaet har blød scrolling) og fastholdt hvert billede i 0,45 s, mens mobil-headerens fold-animation rykker indholdet */
        var ret = function () { var d2 = anker.getBoundingClientRect().top - foer; if (Math.abs(d2) > 0.5) window.scrollTo({ top: window.pageYOffset + d2, behavior: 'instant' }); };
        var t0 = Date.now(); (function hold() { ret(); if (Date.now() - t0 < 450) requestAnimationFrame(hold); })();
      };
      var ids = d.ids || [d.id], fjernes = [];
      ids.forEach(function (n) { var el = ul.querySelector('.br-favs__r[data-id="' + cssE(n) + '"]'); if (el && !erGemt(n)) fjernes.push(el); });
      if (fjernes.length) skub(function () { fjernes.forEach(function (el) { el.remove(); }); opd(); });
      var findes = ul.querySelector('.br-favs__r[data-id="' + cssE(d.id) + '"]');
      if (d.gemt && !findes) {
        var x = aktive().filter(function (y) { return y.id === String(d.id); })[0]; if (!x) return;
        hent(x.h).then(function (p) {
          if (ul.querySelector('.br-favs__r[data-id="' + cssE(d.id) + '"]') || !erGemt(d.id)) return;
          skub(function () { ul.insertAdjacentHTML('afterbegin', raekke(p, x)); if (tom) tom.hidden = true; opd(); });
          var ny = ul.firstElementChild; if (ny) { ny.classList.add('br-favs__r--ny'); setTimeout(function () { ny.classList.remove('br-favs__r--ny'); }, 900); }
        });
      }
    });
  }

  /* Produktsektioner på produktsiden (Andre kiggede også på, Sidst sete, Andre købte også, Mest sete i kategorien, Mere fra serien)
     bygger deres kort selv (ofte i JS). Her får hvert kort et hjerte øverst th. og højst ÉT badge øverst – samme regel som
     kollektionskortene: status (Nyhed/Bestseller/Populær) før Spar, og badget flyttes til venstre. Lagerbadget nederst røres ikke. */
  function berigSektioner() {
    var bokse = document.querySelectorAll('.product-image-container');
    for (var i = 0; i < bokse.length; i++) {
      var b = bokse[i];
      if (b.closest('.br-favs, cart-drawer, .drawer')) continue;
      var kort = b.closest('[data-product-id]'); if (!kort) continue;
      var status = b.querySelector('.pop-badge, .br-pop-badge-wrap');
      var spar = b.querySelectorAll('.br-spar-badge, span[style*="#d12c2c"]');
      for (var j = 0; j < spar.length; j++) spar[j].style.display = status ? 'none' : '';
      if (status && status.classList.contains('pop-badge')) { status.style.left = '8px'; status.style.right = 'auto'; }
      if (kort.querySelector(':scope > .br-fav')) continue;
      var id = kort.getAttribute('data-product-id'), a = kort.querySelector('a[href*="/products/"]');
      var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!id || !m) continue;
      kort.classList.add('br-fav-vaert');
      var knap = document.createElement('button');
      knap.type = 'button'; knap.className = 'br-fav br-fav--kort br-fav--sektion';
      knap.setAttribute('data-br-fav', ''); knap.setAttribute('data-id', id); var hd = m[1]; try { hd = decodeURIComponent(hd); } catch (x) {} knap.setAttribute('data-handle', hd); knap.setAttribute('data-kilde', 'sektion');
      knap.setAttribute('aria-pressed', 'false'); knap.setAttribute('aria-label', 'Gem i favoritter');
      knap.innerHTML = '<span class="br-fav__cirkel">' + HJERTE + '</span>';
      kort.appendChild(knap);
    }
  }

  /* kort der indlæses senere (filtre, søgning, "vis flere", produktsektioner) får hjerte og den rigtige tilstand */
  function cssE(v) { v = String(v); return window.CSS && CSS.escape ? CSS.escape(v) : v.replace(/["\\]/g, '\\var planlagt = false;'); }
  var planlagt = false;
  function planlaeg() { if (planlagt) return; planlagt = true; requestAnimationFrame(function () { planlagt = false; berigSektioner(); opdater(); }); }
  /* Mobil: kompakt-headerens søge-ikon (br-header-kompakt) flyttes fra højre side over til burgeren, så der er to ikoner
     i hver side (burger+søg | logo | hjerte+kurv) og logoet i midten ikke rammes. */
  function flytSoegIkon() {
    var ik = document.querySelector('.br-header__actions .br-header__soeg-ikon'), t = document.querySelector('.br-header__mobile-toggle');
    if (ik && t) t.insertAdjacentElement('afterend', ik);
  }
  function start() {
    flytSoegIkon();
    berigSektioner(); opdater(); initSide();
    var rod = document.querySelector('[data-br-favs]');
    var efterSync = function () { if (rod) visKonto(rod); };
    /* listen tegnes igen, når en synk har ændret den (uanset hvad der udløste synken), og konto-linjen følger token-tilstanden */
    window.addEventListener('br:favoritter-sync', function () { if (rod) { visListe(rod); visKonto(rod); } });
    /* linket fra mailen: nøglen er fanget af <head>-scriptet (ny side) eller af hashchange (linket sat ind i samme fane) */
    var hentLink = function () {
      var l = null; try { l = sessionStorage.getItem('br_fav_l'); } catch (e) {}
      var glemL = function () { try { sessionStorage.removeItem('br_fav_l'); } catch (e) {} };
      if (!l || !API) return false;
      sidstSync = Date.now();
      api({ handling: 'sync', token: l, tilslut: true, poster: laes().p }).then(function (j) {
        glemL(); try { localStorage.setItem(TOK, l); } catch (e) {} try { sessionStorage.removeItem('br_fav_sendt'); } catch (e) {}
        saetKonto(j); fletServer(j.poster); efterSync();
        toast('Din liste er hentet', null); spor('mail_link_aabnet', '0', null, null);
      }).catch(function (e) {
        if (e && e.status === 401) { glemL(); toast('Linket virker ikke længere. Bed om et nyt på favoritsiden.', null); }
        else if (e && e.message === 'for mange') { glemL(); try { localStorage.setItem(TOK, l); } catch (x) {} efterSync(); toast('Listen på din e-mail er fuld (højst 100). Fjern noget, så samles den.', null); }
        else toast('Listen kunne ikke hentes lige nu. Genindlæs siden om lidt.', null);
      });
      return true;
    };
    if (!hentLink() && token()) syncNu().then(efterSync);
    /* fanen får fokus igen (fx efter at man har fjernet noget på telefonen): hent ændringer fra andre enheder, højst hvert minut */
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && token() && Date.now() - sidstSync > 60000) syncNu(); });
    /* siden forlades, mens en synk venter (hjerte trykket < 1,2 s før navigation/luk): send den med sendBeacon, så ændringen ikke tabes */
    window.addEventListener('pagehide', function () {
      if (!syncTimer || !API || !token() || !navigator.sendBeacon) return; clearTimeout(syncTimer); syncTimer = null;
      try { navigator.sendBeacon(API.u, new Blob([JSON.stringify({ handling: 'sync', token: token(), poster: laes().p, k: API.k })], { type: 'text/plain' })); } catch (e) {}
    });
    window.addEventListener('hashchange', function () {
      try { var m = location.hash.match(/(?:^#|&)l=([A-Za-z0-9_-]{40,60})/); if (!m) return; sessionStorage.setItem('br_fav_l', m[1]); history.replaceState(null, '', location.pathname + location.search); } catch (e) { return; }
      hentLink();
    });
    /* produktsiden: når kunden skifter størrelse/farve, viser hjertet om netop den variant er gemt */
    document.addEventListener('change', function () { setTimeout(opdater, 60); }, true);
    try { if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(opdater, 30); }); } catch (e) {}
    try { new MutationObserver(function (ms) { for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { planlaeg(); return; } }).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    window.addEventListener('storage', function (e) { if (e.key === NOGLE) opdater(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) opdater(); });
  }
  window.BRFav = { aktive: aktive, erGemt: erGemt, saet: saet };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
